import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { searchesCount } from '../../../common/utils/tracking/trackSearchCount'
import SearchSurveyBanner from './searchSurveyBanner'

interface IProps {
  currentSite: Site
}

const ThemeForestCustomerSurvey: React.StatelessComponent<IProps> = props => {
  const { currentSite } = props
  const showBanner =
    currentSite === Site.videohive && searchesCount(Site.videohive) > 2

  if (!showBanner) {
    return null
  }

  return (
    <SearchSurveyBanner
      siteId="vh"
      surveyUrl="https://www.surveymonkey.com/r/XRLLWYY"
      surveyText="We need your help to improve VideoHive with some feedback. Interested in helping?"
      surveyLink="Click here"
    />
  )
}
export default ThemeForestCustomerSurvey
